import { isAlphaNumericKey, isNavigationKey } from '@silevis/reactgrid';
import React from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';
import { handleKeyDownDefault } from '../../helpers/global';

class CombinedDropdownCellTemplate {
  getCompatibleCell(cell) {
    return {
      ...cell,
      lenderValue: cell.lenderValue ?? null,
      loanTypeValue: cell.loanTypeValue ?? null,
      lenderOptions: Array.isArray(cell.lenderOptions) ? cell.lenderOptions : [],
      loanTypeOptions: Array.isArray(cell.loanTypeOptions) ? cell.loanTypeOptions : [],
      onLenderSelect: cell.onLenderSelect || (() => {}),
      onLoanTypeSelect: cell.onLoanTypeSelect || (() => {}),
      isLenderLoading: cell.isLenderLoading || false,
      isLoanTypeLoading: cell.isLoanTypeLoading || false,
      nonEditable: cell.nonEditable || false,
      onClick: cell.onClick || (() => {}),
      text: cell.text || ''
    };
  }

  handleKeyDown(cell, keyCode, ctrl, shift, alt) {
    return handleKeyDownDefault(cell, keyCode, ctrl, shift, alt);
  }

  update(cell, cellToMerge) {
    return { ...cell, ...cellToMerge };
  }

  render(cell) {
    const {
      lenderValue,
      loanTypeValue,
      lenderOptions,
      loanTypeOptions,
      onLenderSelect,
      onLoanTypeSelect,
      isLenderLoading,
      isLoanTypeLoading
    } = cell;

    const stopPropagation = e => {
      if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
        e.stopPropagation();
      }
    };

    return (
      <div
        className="d-flex align-items-center justify-content-center w-100 px-2"
        style={{ height: '100%', gap: '0.5rem' }}
        onKeyDown={stopPropagation}
        onPointerDown={e => e.stopPropagation()}
      >
        <Dropdown drop="down" onClick={e => e.stopPropagation()}>
          <Dropdown.Toggle
            size="sm"
            variant="primary"
            id={`combined-lender-${Math.random()
              .toString(36)
              .substr(2, 5)}`}
            style={{ fontSize: '0.85rem', minWidth: '5rem' }}
            disabled={isLenderLoading || isLoanTypeLoading}
          >
            {lenderValue ? lenderOptions.find(o => o.value === lenderValue)?.label : 'N/A'}
          </Dropdown.Toggle>

          <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} style={{ zIndex: 9999, padding: 0 }}>
            {lenderOptions.map(opt => (
              <Dropdown.Item
                key={opt.value}
                eventKey={opt.value}
                active={opt.value === lenderValue}
                onSelect={value => onLenderSelect(value)}
                disabled={opt.value === lenderValue}
              >
                {opt.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        {' / '}

        <Dropdown drop="down" onClick={e => e.stopPropagation()}>
          <Dropdown.Toggle
            size="sm"
            variant="primary"
            id={`combined-loantype-${Math.random()
              .toString(36)
              .substr(2, 5)}`}
            style={{ fontSize: '0.85rem', minWidth: '5rem' }}
            disabled={isLenderLoading || isLoanTypeLoading}
          >
            {loanTypeValue ? loanTypeOptions.find(o => o.value === loanTypeValue)?.label : 'Loan Type...'}
          </Dropdown.Toggle>

          <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} style={{ zIndex: 9999, padding: 0 }}>
            {loanTypeOptions.map(opt => (
              <Dropdown.Item
                key={opt.value}
                eventKey={opt.value}
                active={opt.value === loanTypeValue}
                onSelect={value => onLoanTypeSelect(value)}
                disabled={opt.value === loanTypeValue}
              >
                {opt.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Spinner
          animation="border"
          size="sm"
          style={{ visibility: isLenderLoading || isLoanTypeLoading ? 'visible' : 'hidden' }}
        />
      </div>
    );
  }
}

export const combinedDropdownCell = new CombinedDropdownCellTemplate();
